import { IAddProductGoodsReceipt } from "mobx-stores/_models/product-inventory/product-goods-receipt/product-goods-receipt";
import { IProductGoodsReceiptItemProperties } from "mobx-stores/_models/product-inventory/product-goods-receipt/product-goods-receipt-item";
import { BaseBussiness } from "../base";

class ProductImportWarehouseBusiness extends BaseBussiness<
  IProductGoodsReceiptItemProperties,
  IAddProductGoodsReceipt,
  IAddProductGoodsReceipt,
  IProductGoodsReceiptItemProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }
}

export const productImportWarehouseBusiness =
  new ProductImportWarehouseBusiness("/api/app/product-warehouse-import");
